import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-e7bd48ea"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["innerHTML"];
import { ref, watch } from 'vue';
import { httpClient } from '@common/utils/HttpClient';
import { CacheFactory } from '@common/utils/Cache/Cache';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EIcon',
    props: {
        icon: {},
        iconType: { default: 'key' },
        public: { type: Boolean, default: false }
    },
    setup: function (__props) {
        var cache = new CacheFactory();
        var props = __props;
        var svg = ref('');
        watch(function () { return props.icon; }, getIconSvg, {
            immediate: true
        });
        /**
         *
         */
        function getIconSvg() {
            if (props.iconType === 'source') {
                svg.value = props.icon;
                return;
            }
            var icon = props.icon;
            var iconLink = props.public ? "/img/".concat(props.icon) : "/img/icons/".concat(props.icon, ".svg");
            var cacheCode = "public-icons.".concat(iconLink);
            if (props.public) {
                if (cache.exists(cacheCode)) {
                    svg.value = cache.get(cacheCode);
                }
                httpClient
                    .get(iconLink)
                    .then(function (res) {
                    if (icon === props.icon) {
                        svg.value = res.data;
                        cache.set(cacheCode, res.data);
                    }
                })
                    .catch(function (err) {
                    console.error(err);
                    console.error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0438\u043A\u043E\u043D\u043A\u0443 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: ".concat(iconLink));
                });
            }
            else {
                import("@img/icons/".concat(props.icon, ".svg"))
                    .then(function (module) {
                    if (icon === props.icon) {
                        svg.value = module.default;
                    }
                });
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "e-icon",
                innerHTML: svg.value
            }, null, 8, _hoisted_1));
        };
    }
});
